import { Action } from 'redux';
import { ACTION_CREATOR_NAME } from 'helpers';
import { PaymentActionTypes } from 'store/payment';

export interface RemovePaypalPaymentErrorMessageAction extends Action<PaymentActionTypes.REMOVE_PAYPAL_PAYMENT_ERROR_MESSAGE> {
}

export const removePaypalPaymentErrorMessage: () => RemovePaypalPaymentErrorMessageAction = () => ({
    type: PaymentActionTypes.REMOVE_PAYPAL_PAYMENT_ERROR_MESSAGE
});
removePaypalPaymentErrorMessage[ACTION_CREATOR_NAME] = 'removePaypalPaymentErrorMessage';

export type RemovePaypalPaymentErrorMessageFunc = (...args: Parameters<typeof removePaypalPaymentErrorMessage>) => void;
